import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms'
import { TranslateService } from '@ngx-translate/core';
import { DwRoutingMessageService, DwNewRouteKeyService } from '@webdpt/framework';
import { FxModalService } from 'app/implementation/shared/components/fx-modal/fx-modal.service';
import { FxDapHttpClient } from 'app/implementation/shared/fx-http-client';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-downloadOrder',
  templateUrl: './fx-import-mode.component.html',
  styleUrls: ['./fx-import-mode.component.less'],
  encapsulation: ViewEncapsulation.None,
})
export class fxImportModeComponent implements OnInit {
  @Input() data: any;

  public validateForm: FormGroup;   // 校验FormGroup

  // 构造函数
  constructor(
    protected http: FxDapHttpClient,
    private fb: FormBuilder,
    protected router: DwNewRouteKeyService,
    protected route: ActivatedRoute,
    public dwMessage: DwRoutingMessageService,
    private translateService: TranslateService,
    public fxModalService: FxModalService
  ) {
  }

  // OnInit
  ngOnInit(): void {
    this.pageInit();  // 页面初始化

  }

  // AfterViewInit
  ngAfterViewInit(): void {
  }

  // 过滤条件多语系
  localTextFunc = (key: string): any => {
    // grid多语系
    return this.translateService.instant(key);
  }

  // 初始化页面
  pageInit(): void {
    // 初始化FormGroup
    this.validateForm = this.fb.group({
      'importMode': new FormControl('')
    });
  }

  changeImportMode(data):void{
    this.validateForm.get("importMode").setValue(data);
  }
}

